const NotFound = () => {
  return <div>אין פה כלום</div>
}

export default NotFound
